import React from "react";

// Minimal footer showing only the copyright line. Used on legal pages
// (Terms, Privacy, Legal) so the copyright always shows regardless of
// login state and without the Terms/Privacy footer links.
export default function FooterCopyrightOnly() {
    return (
        <footer className="bg-white dark:bg-gray-900">
            <div className="mx-auto max-w-7xl overflow-hidden py-12 px-4 sm:px-6 lg:px-8">
                <p className="mt-8 text-center text-base text-gray-400 dark:text-gray-500">&copy; 2026 Push Enterprise Technologies LLC.
                    All rights
                    reserved.</p>
            </div>
        </footer>
    )
}
